module.exports = __webpack_public_path__ + "static/irobi-386c10bee9fc0efa59d8b1258723f5be.jpg";